import { render, staticRenderFns } from "./GoogleMyBusinessSummary.vue?vue&type=template&id=715cad86&scoped=true&"
import script from "./GoogleMyBusinessSummary.vue?vue&type=script&lang=js&"
export * from "./GoogleMyBusinessSummary.vue?vue&type=script&lang=js&"
import style0 from "./GoogleMyBusinessSummary.vue?vue&type=style&index=0&id=715cad86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715cad86",
  null
  
)

export default component.exports